import { CALL_API, Schemas } from '../../common/middleware/api';
import { loadUnpagedCenters } from '../centers/actions';

export const TERRITORIES_REQUEST = 'TERRITORIES_REQUEST';
export const TERRITORIES_SUCCESS = 'TERRITORIES_SUCCESS';
export const TERRITORIES_FAILURE = 'TERRITORIES_FAILURE';

export const TERRITORIES_UNPAGED_REQUEST = 'TERRITORIES_UNPAGED_REQUEST';
export const TERRITORIES_UNPAGED_SUCCESS = 'TERRITORIES_UNPAGED_SUCCESS';
export const TERRITORIES_UNPAGED_FAILURE = 'TERRITORIES_UNPAGED_FAILURE';

export const FRANCHISEE_TERRITORIES_REQUEST = 'FRANCHISEE_TERRITORIES_REQUEST';
export const FRANCHISEE_TERRITORIES_SUCCESS = 'FRANCHISEE_TERRITORIES_SUCCESS';
export const FRANCHISEE_TERRITORIES_FAILURE = 'FRANCHISEE_TERRITORIES_FAILURE';

export const TERRITORY_FETCH_REQUEST = 'TERRITORY_GET_REQUEST';
export const TERRITORY_FETCH_SUCCESS = 'TERRITORY_GET_SUCCESS';
export const TERRITORY_FETCH_FAILURE = 'TERRITORY_GET_FAILURE';

export const TERRITORY_CREATE_REQUEST = 'TERRITORY_CREATE_REQUEST';
export const TERRITORY_CREATE_SUCCESS = 'TERRITORY_CREATE_SUCCESS';
export const TERRITORY_CREATE_FAILURE = 'TERRITORY_CREATE_FAILURE';

export const TERRITORY_UPDATE_REQUEST = 'TERRITORY_UPDATE_REQUEST';
export const TERRITORY_UPDATE_SUCCESS = 'TERRITORY_UPDATE_SUCCESS';
export const TERRITORY_UPDATE_FAILURE = 'TERRITORY_UPDATE_FAILURE';

export const loadTerritories = ({ franchiseeId, ...options }) => ({
	[CALL_API]: {
		types: [TERRITORIES_REQUEST, TERRITORIES_SUCCESS, TERRITORIES_FAILURE],
		endpoint: 'api/territories',
		request: { franchiseeId, ...options },
		schema: Schemas.TERRITORY_ARRAY
	},
	franchiseeId
});

export const loadTerritoriesByFranchisee = (franchiseeId) => ({
	[CALL_API]: {
		types: [FRANCHISEE_TERRITORIES_REQUEST, FRANCHISEE_TERRITORIES_SUCCESS, FRANCHISEE_TERRITORIES_FAILURE],
		endpoint: 'api/territories/unpaged',
		request: { franchiseeId },
		schema: Schemas.FRANCHISEE_ALL_TERRITORIES
	}
});

export const loadUnpagedTerritories = (options) => ({
	[CALL_API]: {
		types: [TERRITORIES_UNPAGED_REQUEST, TERRITORIES_UNPAGED_SUCCESS, TERRITORIES_UNPAGED_FAILURE],
		endpoint: 'api/territories/unpaged',
		request: options,
		schema: Schemas.TERRITORY_ARRAY
	}
});

export const fetchTerritory = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [TERRITORY_FETCH_REQUEST, TERRITORY_FETCH_SUCCESS, TERRITORY_FETCH_FAILURE],
		endpoint: `api/territories/${id}`,
		schema: Schemas.TERRITORY,
		onSuccessEvent
	}
});

export const createTerritory = (territory, history) => ({
	[CALL_API]: {
		types: [TERRITORY_CREATE_REQUEST, TERRITORY_CREATE_SUCCESS, TERRITORY_CREATE_FAILURE],
		endpoint: 'api/territories',
		method: 'POST',
		request: territory,
		schema: Schemas.TERRITORY,
		form: 'territory',
		transition: {
			history,
			successPath: (response) => {
				const { id, franchiseeId } = response.entities.territories[response.result];
				return `/franchisees/${franchiseeId}/territories/${id}`;
			}
		}
	}
});

export const updateTerritory = (id, territory) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [TERRITORY_UPDATE_REQUEST, TERRITORY_UPDATE_SUCCESS, TERRITORY_UPDATE_FAILURE],
			endpoint: `api/territories/${id}`,
			method: 'PUT',
			request: territory,
			schema: Schemas.TERRITORY,
			form: 'territory',
			onSuccessEvent: () => {
				dispatch(loadUnpagedCenters());
			}
		}
	});
}